import { DimeEmptyDescription, DimeEmptyHeader, DimeEmptyTitle } from './DimeEmpty.js';
import type { DimeEmptyState } from './lib/dime-empty-state.js';

/** The body of an empty picker list: what's missing and why, sized for a popup. */
export function DimePickerEmpty({ title, description }: Omit<DimeEmptyState, 'action'>) {
  return (
    <DimeEmptyHeader className="gap-1 px-2 py-2 text-balance">
      <DimeEmptyTitle className="text-foreground">{title}</DimeEmptyTitle>
      {description ? (
        <DimeEmptyDescription className="text-sm">{description}</DimeEmptyDescription>
      ) : null}
    </DimeEmptyHeader>
  );
}
